import { render, staticRenderFns } from "./seatsModel.vue?vue&type=template&id=55180cb3&scoped=true"
import script from "./seatsModel.vue?vue&type=script&lang=js"
export * from "./seatsModel.vue?vue&type=script&lang=js"
import style0 from "./seatsModel.vue?vue&type=style&index=0&id=55180cb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55180cb3",
  null
  
)

export default component.exports